import React from 'react';
import {
  Box,
  Button,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import { maskEmail, maskPhone } from '../../../../system/preview';
import { DeliverySelectorProps } from '../types';
import DisclosureText from './DisclosureText';

const DeliverySelector: React.FC<DeliverySelectorProps> = ({
  report,
  selected,
  onChange,
  onSend,
  isLoading,
}) => {
  const hasPhone = Boolean(report.phone);

  return (
    <Box>
      <Typography
        variant="h1"
        gutterBottom
        sx={{
          fontWeight: 700,
          mb: 3,
        }}
      >
        Listing Access Verification
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        To protect your listing data, we require additional verification. Once
        you receive the passcode, enter it on this page to preview your
        listing&apos;s information.
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          mt: 3,
          mb: 1,
        }}
      >
        Get your one time passcode sent to:
      </Typography>

      <RadioGroup
        value={selected}
        onChange={(e) => onChange(e.target.value as 'email' | 'sms')}
      >
        <FormControlLabel
          value="email"
          control={<Radio />}
          label={
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
              }}
            >
              Email to {maskEmail(report.email)}
            </Typography>
          }
          sx={{
            mb: 1,
          }}
        />
        {hasPhone && (
          <FormControlLabel
            value="sms"
            control={<Radio />}
            label={
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                }}
              >
                Text to {maskPhone(report.phone!)}
              </Typography>
            }
            sx={{
              mb: 1,
            }}
          />
        )}
      </RadioGroup>

      {selected === 'sms' && <DisclosureText />}

      <Button
        variant="contained"
        color="primary"
        onClick={onSend}
        disabled={isLoading}
        sx={{
          mt: 3,
          px: 5,
          py: 1,
        }}
      >
        {isLoading ? <CircularProgress size={24} /> : 'Send'}
      </Button>
    </Box>
  );
};

export default React.memo(DeliverySelector);
